import {
    IncidentDto
   
  } from '@cradua/data';
  import { createAction, props } from '@ngrx/store';
  
  /**
   * Load Incidents Collection Actions
   */
  
  export const loadIncident = createAction("[Incident] Load Incident");

  export const loadIncidentSuccess = createAction(
    "[Incident] Load Incident Success",
    props<{ incident: IncidentDto[] }>()
  );
  
  export const loadIncidentFailure = createAction(
    "[Incident] Load Incident Failure",
    props<{ error: any }>()
  );
  
  /**
   * Add Incidents to Collection Actions
   */
  export const addIncident = createAction(
    "[Incident] Add Incident",
    props<{
      newIncident: IncidentDto;
    }>()
  );
  
  export const addIncidentSuccess = createAction(
    "[Incident] Add Incident Success",
    props<{ newIncident: IncidentDto }>()
  );
  
  export const addIncidentFailure = createAction(
    "[Incident] Add Incident Failure",
    props<{ error: any }>()
  );
  
  /**
   * Update Incident Collection Actions
   */
  export const updateIncident = createAction(
    "[Incident] Update Incident",
    props<{ updateIncident: IncidentDto }>()
  );
  
  export const updateIncidentSuccess = createAction(
    "[Incident] Update Incident Success",
    props<{ updateIncident: IncidentDto }>()
  );
  
  export const updateIncidentFailure = createAction(
    "[Incident] Update Incident Failure",
    props<{ error: any }>()
  );
  


  /**
 * Fetch Incident-record Collection Actions
 */
export const fetchIncidentRecord = createAction(
  "[Incident-record] Fetch Incident Record",
  props<{ fetch: any }>(),
);

export const fetchIncidentRecordSuccess = createAction(
  "[Incident-record] Fetch Incident Record Success",
  props<{ record: IncidentDto[] }>(),
);

export const fetchIncidentRecordFailure = createAction(
  "[Incident-record] Fetch Incident Record Failure",
  props<{ error: any }>(),
);

  /**
   * Search for record Collection Actions
   */
  export const searchIncidentRecord = createAction(
    "[Incident] Search  Incident Record",
    props<{ query: string }>()
  );
  
  /**
   * Search for record Collection Actions
   */
  export const searchIncidentIdRecord = createAction(
    "[Incident] Search  Incident Id Record",
    props<{ query: string }>()
  );
  
  /**
   * Remove Incident Collection Actions
   */
  export const removeIncident = createAction(
    "[Incident] Remove Incident",
    props<{ id: string }>()
  );
  
  export const removeIncidentSuccess = createAction(
    "[Incident] Remove Incident Success",
    props<{ id: string }>()
  );
  
  export const removeIncidentFailure = createAction(
    "[Incident] Remove Incident Failure",
    props<{ error: any }>()
  );
  

  /**
 * Fetch Incident-record By Id Collection Actions
 */
export const fetchByIdIncidentRecord = createAction(
  "[Incident-record] Fetch Incident Record By Id",
  props<{ id: string }>(),
);

export const fetchByIdIncidentRecordSuccess = createAction(
  "[Incident-record] Fetch Incident Record By Id Success",
  props<{ record: IncidentDto[] }>(),
);

export const fetchByIdIncidentRecordFailure = createAction(
  "[Incident-record] Fetch Incident Record By Id Failure",
  props<{ error: any }>(),
);



export const clearIncident = createAction("[Incident] Clear Incident");

export const clearIncidentSuccess = createAction(
  "[Incident] Clear Incident Success",
  props<{ Incident: IncidentDto[] }>(),
);
